module.exports = __webpack_public_path__ + "static/media/complete.18b5ea53.png";